<div id="donate-button-container">
    <button id="paypal-donate-button" (click)="openPayPal()">PayPal</button>
</div>